export const getYear = state => state.reportVehicleCosts.getIn(['list', 'year'])

export const getData = state => state.reportVehicleCosts.getIn(['list', 'data'])
export const getFetching = state => state.reportVehicleCosts.getIn(['list', 'fetching'])
export const getError = state => state.reportVehicleCosts.getIn(['list', 'error'])

export const getDetailsData = state => state.reportVehicleCosts.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportVehicleCosts.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportVehicleCosts.getIn(['details', 'error'])
